module.exports = __webpack_public_path__ + "c221c0f962143579f214c2e6d01512c7.png";